import './footer.css';

function Footer(){

    return(
       <footer>
            <h6>Diogo Ferreira</h6>
            <small>@copyright 2025</small>
       </footer>
    );
} 

export default Footer;